import React, { createContext, useState, useContext } from 'react';
import { Snackbar, Alert } from '@mui/material';

const SnackbarContext = createContext();

export const useSnackbar = () => useContext(SnackbarContext);

export const SnackbarProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('success');
  const [duration, setDuration] = useState(5000);

  const showSnackbar = (message, severity = 'success', autoHideDuration = null) => {
    setMessage(message);
    setSeverity(severity);
    // Use provided duration, or default to 5 seconds
    if (autoHideDuration !== null) {
      setDuration(autoHideDuration);
    } else {
      setDuration(15000); // Default 5 seconds
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      <Snackbar
        open={open}
        autoHideDuration={duration}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        key={message}
        sx={{
          '& .MuiSnackbarContent-root': {
            borderRadius: '16px',
            minWidth: '320px',
            maxWidth: '440px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.18)',
          },
        }}
      >
        <Alert
          onClose={handleClose}
          severity={severity}
          variant="filled"
          sx={{
            width: '100%',
            borderRadius: '16px',
            alignItems: 'flex-start',
            fontSize: '0.95rem',
            boxShadow: 'none',
            '& .MuiAlert-icon': {
              marginTop: '4px',
            },
          }}
        >
          {message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};